import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnLprReasonGroup extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public reasons: string[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
